import React from 'react';
import { AddIcon } from "@etiquette-ui/icons";
import { PRIMARY } from '@etiquette-ui/colors';
import { CustomSecondaryButton } from "components/Buttons";

const SecondaryButton = ({ label, onClick }) => {
  return (
    <CustomSecondaryButton
      onClick={onClick}
      type="button"
    >
      <AddIcon
        styles={{
          svg: { width: "20px", height: "20px", marginRight: "8px" },
          line: {
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5px",
            stroke: PRIMARY,
          },
        }}
      />
        {label}
    </CustomSecondaryButton>

  )
}
export default SecondaryButton;